import { Button } from '@/common/ui/Form/Button'
import { useCurrentOrg, useMyOrgs, useChangeOrg } from '../model'
import { Menu, MenuItem } from '@/common/ui/Menu'
import { cn } from '@/common/lib/cn/cn'

export type OrgPickerListProps = {
    afterSelect?: () => void
    menuClassName?: string
}

export const OrgPickerList = ({ afterSelect, menuClassName }: OrgPickerListProps) => {
    const { data: myOrgs } = useMyOrgs()
    const { data: currentOrg } = useCurrentOrg()
    const changeOrg = useChangeOrg()

    const handleSelectOrg = async (orgId: string) => {
        await changeOrg(orgId)
        afterSelect?.()
    }

    return (
        <Menu className={cn('w-full', menuClassName)}>
            {myOrgs?.map(org => (
                <MenuItem
                    key={org.id}
                    data-close-dropdown
                    onClick={() => handleSelectOrg(org.id)}
                    active={currentOrg?.id == org.id}
                >
                    <div className='flex flex-col items-start overflow-hidden'>
                        <span>{org.name}</span>
                    </div>
                </MenuItem>
            ))}
        </Menu>
    )
}

export const SelectOrg = () => {
    const handleAfterSelect = () => {
        const checkbox = document.getElementById('orgChangeModal') as HTMLInputElement
        if (checkbox) {
            checkbox.checked = false
        }
    }

    return (
        <>
            <h3 className='text-lg font-bold'>Выбор организации</h3>
            <OrgPickerList afterSelect={handleAfterSelect} />
            <Button as='label' htmlFor='addOrgModal' emphasis='secondary' variant='ghost' size='lg' className='w-full'>
                Добавить организацию
            </Button>
        </>
    )
}
